module.exports = __webpack_public_path__ + "img/STEP2.2c0c294f.png";